import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useViewBids = ({ id }: { id: string }) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const urlKey = `${t("view-bids-api")}/${id}`;
  const { data, refetch, isLoading, isError, isPlaceholderData } = useQuery({
    queryKey: [`view-bids`],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      return res.data;
    }
    // placeholderData: (previousData) => previousData
  });

  return { data: data?.data, refetch, isLoading, isError, isPlaceholderData };
};
